/* @ngInject */
const railway = (
  railwayAsk,
  railwayGo,
  railwayLocal,
  railwayData,
  railwayFormat,
  railwayMetadata,
  railwayRequest
) => {
  const self = {}

  self.new = () => {
    return {
      areaId: null,
      number: null,
      length: null,
      begin: null,
      end: null,
    }
  }

  self.go = railwayGo
  self.local = railwayLocal
  self.format = railwayFormat
  self.metadata = railwayMetadata
  self.data = railwayData
  self.ask = railwayAsk
  self.request = railwayRequest

  return self
}

export default railway



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/services/railway.service.js